import { render, staticRenderFns } from "./transportistas.vue?vue&type=template&id=765e9811&scoped=true"
import script from "./transportistas.vue?vue&type=script&lang=js"
export * from "./transportistas.vue?vue&type=script&lang=js"
import style0 from "./transportistas.vue?vue&type=style&index=0&id=765e9811&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "765e9811",
  null
  
)

export default component.exports